export const DISCORD_URL = "https://discord.gg/TjmyK45AWh";

export const CHECKOUT_LINKS = {
  monthly: "https://buy.stripe.com/14A00lfnQ8F82Rse4r8IU02",
  lifetime: "https://buy.stripe.com/8x28wR5Ngg7AajU8K78IU01",
  woofer_once: "https://buy.stripe.com/7sYcN72B41cG77I5xV8IU03",
  woofer_lifetime: "https://buy.stripe.com/4gMfZj4JcaNg8bM9Ob8IU04",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1757774636742-0a5dc7e5c07a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxmcHMlMjBnYW1lJTIwc2NyZWVueDB8fHx8MTc5MjQ1MTI0Nnww&ixlib=rb-4.1.0&q=85";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
